import { z } from 'zod';
import { extendZodWithOpenApi } from '@hono/zod-openapi';
import 'zod-openapi/extend';
extendZodWithOpenApi(z);

export const GmodPositionSchema = z
	.object({
		x: z.number().openapi({
			example: 0,
			description: 'X coordinate',
		}),
		y: z.number().openapi({
			example: 0,
			description: 'Y coordinate',
		}),
		z: z.number().openapi({
			example: 0,
			description: 'Z coordinate',
		}),
	})
	.openapi({ ref: 'Gmod Position' });

export type GmodPositionInput = z.infer<typeof GmodPositionSchema>;
